import Base from "./base";
import apiDispatcher from "@/utils/api-dispatcher";
import { CREATE_COMPLAIN, POST_COMPLAIN_PHOTO } from "@/utils/api-url";

export default class Complain extends Base {
  constructor(params = {}) {
    super(params);
  }

  static resourceName() {
    return "complain";
  }

  static createComplain(params) {
    return apiDispatcher(CREATE_COMPLAIN(params));
  }

  static postComplainPhoto(params) {
    return apiDispatcher(POST_COMPLAIN_PHOTO(params.image, params.complainId));
  }
}
